var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIllo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 437,
    viewBox: "0 0 415 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.331 31.6435C368.568 20.0337 352.926 13.4176 337.12 12.5325C321.313 11.6497 305.438 16.2616 291.857 24.3975C285.959 28.3104 288.927 32.648 301.84 28.6158C309.014 26.4112 312.712 25.7814 318.183 25.7432C321.972 25.7169 323.103 31.0089 319.591 32.4285C319.5 32.4643 319.409 32.5 319.319 32.5287C304.054 37.6679 288.032 40.5548 271.932 41.0654C268.368 41.1776 264.507 41.2658 262.052 44.3317C260.871 45.8062 260.676 47.8915 261.718 49.4685C262.959 51.3462 265.249 51.4107 267.292 51.3128C283.564 50.5207 299.213 44.6896 315.434 43.1984C336.767 41.2348 358.698 47.2186 376.222 59.506C379.059 63.2781 381.793 67.1337 384.504 70.9631L392.52 75.4677C395.539 59.9259 390.092 43.2533 379.331 31.6435Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.805 183.799C281.34 193.589 301.94 196.349 318.493 188.404C319.498 187.922 320.516 187.402 321.626 187.302C322.735 187.204 323.974 187.643 324.467 188.64C324.949 189.619 324.568 190.85 323.826 191.651C323.084 192.453 322.055 192.916 321.046 193.331C303.431 200.608 282.786 200.174 265.493 192.162",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.167 180.235C274.376 183.513 279.703 184.911 285.892 185.353C287.61 185.474 289.703 185.379 290.965 184.033C291.301 183.675 291.547 183.253 291.707 182.802C292.351 180.977 291.411 178.98 289.662 178.152C283.432 175.198 274.908 166.368 271.677 163.741C269.399 161.887 271.57 165.934 269.919 163.584C268.487 161.546 266.597 158.886 264.002 158.292C260.69 157.535 258.891 161.112 258.369 163.791C257.04 170.605 264.057 177.016 269.167 180.235Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M386.482 108.345C383.759 128.489 374.731 147.734 360.981 162.705C359.406 164.421 357.505 166.201 355.176 166.21C351.507 166.225 349.326 161.625 350.199 158.06C351.073 154.496 353.847 151.776 356.24 148.991C363.059 141.056 367.507 131.107 368.874 120.733C369.258 117.81 368.416 113.723 365.467 113.771C360.692 113.849 362.594 123.775 357.911 124.703C355.737 125.135 353.802 122.892 353.611 120.685C353.423 118.478 354.406 116.364 355.212 114.303C360.256 101.395 358.617 86.0775 350.956 74.5298L386.482 108.345Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2982 166.191C52.7805 171.863 45.6968 179.667 40.8749 188.69C39.973 190.377 38.5653 192.405 36.702 191.971C35.5615 191.706 34.8266 190.508 34.7384 189.339C34.6525 188.17 35.0748 187.03 35.5376 185.951C38.081 180.042 42.0607 174.754 47.0377 170.677L61.2982 166.191Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4586 150.168C17.4884 164.893 4.51386 187.137 1.07578 210.908C0.951718 211.76 1.25711 212.64 1.92755 213.179C3.66448 214.58 5.776 212.129 6.37486 210.051C7.38648 206.546 7.72528 202.844 9.09479 199.463C9.73659 197.881 10.6838 196.344 11.8815 195.118C13.2272 193.741 15.4675 195.295 14.6849 197.055C9.68172 208.312 7.07393 220.63 7.11688 232.949C7.12165 234.235 7.20038 235.65 8.40526 236.432C9.50516 237.146 10.9462 236.962 11.9555 236.127C13.9286 234.49 14.0145 231.935 14.1433 229.575C15.4771 204.762 28.7379 180.858 49.0848 166.595L36.4586 150.168Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3557 90.475C106.948 94.0419 122.399 84.391 134.352 73.7642C146.305 63.1374 157.748 50.5947 173.197 46.448C176.804 45.4793 182.022 46.052 182.437 49.762C182.826 53.2335 178.536 55.054 175.172 55.9868C163.159 59.3175 152.01 65.7165 143.077 74.4107C139.971 77.4337 137.301 83.0358 140.868 85.5004C145.888 88.9695 151.86 78.963 157.061 78.9344C158.416 78.9272 159.411 80.2299 159.046 81.535C157.55 86.9033 152.497 90.9068 147.257 93.1567C141.443 95.6548 135.056 96.6903 129.377 99.4818C120.309 103.941 113.981 112.356 106.847 119.514C99.7135 126.671 90.3059 133.101 80.2947 131.708",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M374.724 165.154L374.798 166.924C375.041 166.347 375.06 165.714 374.724 165.154Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.609 222.916C153.439 226.545 148.269 230.174 143.099 233.803C141.677 234.8 140.205 235.821 138.508 236.189C136.812 236.556 134.812 236.105 133.849 234.66C132.968 233.338 133.173 231.527 133.915 230.122C134.657 228.716 135.85 227.616 136.974 226.495C141.65 221.831 145.492 216.333 148.266 210.34L158.609 222.916Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.238 221.129C153.628 232.794 142.917 244.552 130.11 253.752C128.287 255.061 126.302 256.362 124.062 256.505C121.821 256.648 119.323 255.181 119.144 252.943C118.877 249.574 123.112 247.741 122.78 244.325C122.406 240.474 116.785 237.356 113.237 237.181C105.098 236.781 94.9942 246.591 89.1177 251.311C86.5529 253.37 83.8544 255.896 83.6922 259.179C82.9215 274.683 103.865 251.922 100.186 270.026C99.2053 274.85 103.218 279.662 107.981 280.913C112.74 282.163 117.83 280.593 122.112 278.171C126.397 275.75 130.155 272.493 134.371 269.952C137.048 268.337 140.896 267.179 142.972 269.515C145.494 272.352 142.6 276.558 140.441 279.679C136.196 285.816 134.803 293.842 136.731 301.05C137.389 303.509 138.508 306.005 140.923 307.179C142.137 307.768 143.566 307.845 144.762 307.217C147.212 305.931 147.186 302.863 146.506 300.427C145.425 294.097 150.266 294.41 150.416 297.254C151.084 309.72 160.21 318.362 172.436 321.26L164.238 221.129Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.627 320.008V298.351C316.627 287.13 309.548 272.442 303.266 263.145C296.984 253.847 293.625 242.881 293.625 231.66V202.574C293.625 198.322 290.177 194.875 285.926 194.875H283.473C275.573 194.875 269.17 201.278 269.17 209.178V277.415V312.277H269.167L175.332 339.026L185.575 367.418C188.116 374.466 192.193 380.781 197.438 385.949C197.576 386.085 197.717 386.219 197.855 386.357C198.134 386.624 198.416 386.892 198.702 387.154C199.559 387.939 200.441 388.7 201.355 389.425C201.661 389.666 201.968 389.907 202.278 390.144C202.434 390.258 202.589 390.377 202.744 390.494C203.214 390.845 203.691 391.184 204.17 391.513C204.655 391.845 205.144 392.167 205.638 392.484C205.969 392.694 206.301 392.899 206.638 393.102C207.642 393.71 208.673 394.283 209.727 394.822L222.613 436.141H314.921L299.742 374.929C299.79 374.874 316.627 359.129 316.627 320.008Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M285.78 366.633L267.032 375.444C253.093 381.993 245.862 397.592 249.87 412.461L256.252 436.134H222.609L209.723 394.815C208.668 394.276 207.637 393.703 206.633 393.095C206.296 392.892 205.965 392.687 205.633 392.477C205.139 392.162 204.65 391.837 204.166 391.506C203.684 391.174 203.209 390.833 202.739 390.487C202.584 390.37 202.429 390.253 202.274 390.136C201.964 389.9 201.656 389.662 201.35 389.418C200.439 388.693 199.554 387.932 198.697 387.147C198.411 386.884 198.129 386.62 197.85 386.35C197.712 386.214 197.571 386.08 197.433 385.942C192.189 380.774 188.111 374.459 185.57 367.411L175.327 339.018L269.162 312.27V209.173C269.162 202.827 273.297 197.444 279.021 195.576L279.023 332.472V354.567C279.026 359.492 281.586 364.061 285.78 366.633Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.17 246.508L220.595 229.248L171.214 167.945C166.447 162.028 157.789 161.095 151.872 165.862C145.955 170.629 145.022 179.288 149.789 185.205L199.17 246.508Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.502 188.089C161.506 191.248 157.512 194.407 153.515 197.566C152.766 198.158 151.988 198.766 151.065 199.007C150.142 199.25 149.025 199.028 148.493 198.234C147.796 197.194 148.395 195.776 149.176 194.798C151.328 192.107 154.761 190.573 156.589 187.65C157.681 185.901 158.089 183.821 158.939 181.943C160.423 178.66 163.324 176.045 166.745 174.909L165.502 188.089Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.166 359.189H263.434C268.673 359.189 272.918 354.942 272.918 349.705V140.956C272.918 135.716 268.671 131.472 263.434 131.472H172.166C166.927 131.472 162.682 135.719 162.682 140.956V349.703C162.68 354.942 166.927 359.189 172.166 359.189Z",
    fill: "#24292E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.375 352.155H197.225V353.718H238.375V352.155Z",
    fill: "#606060"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.845 137.393H198.349V138.956H238.845V137.393Z",
    fill: "#606060"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M267.13 147.932H168.466V345.69H267.13V147.932Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M267.132 161.019C260.781 158.136 253.387 157.046 246.489 157.948C231.909 159.857 219.175 168.467 207.344 177.202C204.027 179.65 199.707 182.234 196.075 180.28C191.468 177.801 192.873 170.476 196.633 166.838C200.394 163.199 205.671 161.243 208.88 157.11C209.67 156.094 210.338 154.782 209.94 153.558C209.069 150.895 205.08 151.881 202.708 153.369C193.856 158.926 185.007 164.485 176.155 170.042C173.7 171.583 171.174 173.148 168.466 174.12V187.256C169.709 185.939 170.832 184.493 172.293 183.429C174.301 181.964 177.444 181.48 179.071 183.358C181.192 185.803 179.03 189.489 178.911 192.725C178.68 198.983 186.868 202.612 192.804 200.617C198.74 198.623 202.796 193.307 206.926 188.602C213.633 180.962 221.645 174.167 231.174 170.631C240.706 167.098 251.929 167.193 260.554 172.578C263.09 174.162 265.321 176.25 267.13 178.653V161.019H267.132Z",
    fill: "url(#paint14_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.927 288.454C262.253 292.219 259.137 295.674 255.675 298.73C248.178 305.349 239.043 310.047 229.237 312.075C219.338 314.117 209.016 313.377 199.361 310.5C191.158 308.057 184.251 303.333 178.999 296.557C173.953 290.036 170.663 282.187 169.146 274.11C168.843 272.5 168.618 270.868 168.466 269.229V323.179C170.761 326.104 173.715 328.554 176.776 330.58C180.39 332.97 184.334 335.115 188.211 337.038C192.086 338.959 196.445 340.787 200.859 340.581C204.7 340.4 208.802 338.126 207.828 333.689C206.921 330.341 203.717 327.514 198.409 324.069C197.211 323.293 197.022 321.592 198.063 320.607C198.07 320.6 198.082 320.59 198.089 320.583C199.003 319.719 200.577 319.452 201.856 319.349C208.646 318.805 215.146 321.862 221.886 320.95C226.653 320.306 231.36 318.982 236.185 318.817C237.766 318.762 239.895 318.703 241.197 319.774C242.564 320.9 242.39 323.155 241.758 324.67C241.274 325.825 238.592 330.973 238.241 331.935C237.079 335.106 237.28 338.906 240.508 340.758C244.034 342.776 247.954 340.536 251.082 338.811C254.907 336.695 258.318 333.982 261.38 330.866C263.489 328.716 265.452 326.445 267.137 323.978V285.186C266.421 286.302 265.684 287.39 264.927 288.454Z",
    fill: "url(#paint15_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.131 147.932V161.019C260.78 158.137 253.389 157.046 246.486 157.948C231.906 159.857 219.173 168.468 207.343 177.202C204.027 179.653 199.706 182.234 196.075 180.28C191.467 177.801 192.873 170.476 196.635 166.838C200.395 163.197 205.671 161.241 208.88 157.108C209.672 156.092 210.34 154.78 209.939 153.556C209.068 150.893 205.079 151.878 202.707 153.367C193.856 158.924 185.004 164.481 176.155 170.042C173.702 171.584 171.173 173.146 168.467 174.117V147.932H267.131Z",
    fill: "url(#paint16_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.132 323.978V345.69H168.466V323.176C170.761 326.101 173.715 328.552 176.776 330.577C180.39 332.968 184.334 335.113 188.211 337.036C192.086 338.957 196.445 340.784 200.859 340.579C204.7 340.398 208.802 338.124 207.828 333.686C206.921 330.339 203.717 327.511 198.409 324.066C197.211 323.291 197.022 321.59 198.063 320.604C198.07 320.597 198.082 320.588 198.089 320.58C199.003 319.717 200.577 319.45 201.856 319.347C208.646 318.803 215.146 321.859 221.886 320.948C226.653 320.304 231.36 318.979 236.185 318.815C237.766 318.76 239.895 318.7 241.197 319.772C242.564 320.898 242.39 323.152 241.758 324.667C241.274 325.822 238.592 330.971 238.241 331.933C237.079 335.103 237.28 338.904 240.508 340.756C244.034 342.774 247.954 340.534 251.082 338.809C254.907 336.692 258.318 333.98 261.38 330.864C263.482 328.716 265.448 326.445 267.132 323.978Z",
    fill: "url(#paint17_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.335 236.95C174.385 234.736 175.602 232.61 176.754 230.451C178.901 226.437 180.929 222.214 180.965 217.567C180.987 215.217 180.433 212.117 177.682 211.621C175.28 211.187 172.875 212.912 171.1 214.305C170.179 215.028 169.298 215.808 168.466 216.636V257.833C168.862 253.214 169.704 248.633 170.849 244.231C171.5 241.741 172.228 239.283 173.335 236.95Z",
    fill: "url(#paint18_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M262.635 190.916C264.207 191.422 265.717 192.109 267.132 192.959V184.851C259.578 177.758 247.482 174.673 237.692 176.398C228.402 178.032 220.306 183.914 213.724 190.403C210.636 193.45 207.931 196.778 205.175 200.116C203.016 202.731 200.778 205.303 198.998 208.205C197.366 210.867 195.691 214.379 196.762 217.555C197.829 220.711 201.365 223.014 204.641 221.866C207.89 220.731 210.154 217.56 212.056 214.866C214.416 211.528 216.823 208.298 219.913 205.585C223.115 202.777 228.511 198.749 232.47 197.241C235.097 196.442 237.535 197.812 233.591 200.66C231.413 202.724 228.848 204.788 230.282 208.119C232.033 212.191 236.254 211.958 239.847 210.805C244.082 209.445 248.687 208.104 252.893 210.347C256.493 212.263 259.204 215.961 261.174 219.437C264.861 225.941 266.767 233.564 267.13 241.058V214.549C264.567 209.817 261.499 205.356 257.989 201.274C256.877 199.98 255.706 198.697 255.014 197.139C254.322 195.581 254.193 193.655 255.152 192.243C256.682 189.993 260.043 190.084 262.635 190.916Z",
    fill: "url(#paint19_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.558 287.956C199.687 285.438 188.86 270.534 191.377 254.665C192.468 247.794 195.879 241.867 200.687 237.563C206.983 231.92 215.671 229.057 224.67 230.484C240.541 233.001 251.366 247.906 248.849 263.777C248.033 268.921 245.917 273.533 242.889 277.333C236.571 285.262 226.285 289.657 215.558 287.956Z",
    fill: "#FFD23D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M220.096 285.491C218.736 285.491 217.367 285.386 216 285.169C209.069 284.069 202.98 280.337 198.855 274.659C194.73 268.98 193.064 262.037 194.164 255.104C195.106 249.156 198.094 243.671 202.57 239.66C208.489 234.354 216.384 232.025 224.226 233.268C231.157 234.368 237.246 238.1 241.369 243.778C245.492 249.456 247.16 256.402 246.06 263.333C245.349 267.816 243.488 272.048 240.677 275.577C235.65 281.89 228.022 285.491 220.096 285.491ZM216.248 283.611C225.018 285.001 233.906 281.547 239.448 274.594C242.09 271.28 243.838 267.301 244.507 263.087C245.54 256.571 243.974 250.043 240.097 244.706C236.22 239.369 230.499 235.859 223.983 234.826C216.611 233.657 209.19 235.847 203.624 240.834C199.415 244.603 196.61 249.759 195.722 255.352C194.689 261.868 196.256 268.396 200.131 273.733C204.006 279.07 209.732 282.577 216.248 283.611Z",
    fill: "#F66A0A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M219.994 246.808C219.994 253.663 214.437 259.217 207.585 259.217C214.439 259.217 219.994 264.774 219.994 271.626C219.994 264.772 225.551 259.217 232.403 259.217C225.551 259.22 219.994 253.663 219.994 246.808Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M177.021 239.489C180.708 236.654 181.691 231.513 179.312 227.516L165.338 204.048C161.055 198.733 153.275 197.895 147.959 202.176C141.612 207.093 141.178 216.522 147.047 222L165.166 238.918C168.444 241.984 173.462 242.225 177.021 239.489Z",
    fill: "url(#paint20_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M172.371 293.868C176.666 288.519 176.523 281.275 172.054 277.689L166.301 273.402C161.833 269.816 154.73 271.242 150.438 276.592C146.143 281.941 146.286 289.184 150.755 292.77L156.507 297.058C160.976 300.646 168.079 299.217 172.371 293.868Z",
    fill: "url(#paint21_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.073 266.666C177.367 261.317 177.224 254.073 172.755 250.487L167.003 246.2C162.534 242.614 155.431 244.041 151.139 249.39C146.845 254.739 146.988 261.983 151.456 265.569L157.209 269.856C161.675 273.445 168.778 272.015 173.073 266.666Z",
    fill: "url(#paint22_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.026 241.299C279.026 244.635 280.774 249.433 283.695 249.433C283.695 249.433 279.026 251.936 279.026 255.899L275.771 246.811L279.026 241.299Z",
    fill: "url(#paint23_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.471 194.872C281.335 194.872 279.023 198.639 279.023 202.65V195.578C279.023 195.578 281.018 194.872 283.471 194.872Z",
    fill: "#CED2D5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M332.696 54.1259C331.69 52.7039 331.282 50.9408 331.565 49.2205L338.594 6.41275L338.597 6.39844C338.769 5.18163 339.434 4.08889 340.439 3.37789C340.443 3.3755 340.446 3.37312 340.451 3.36835L344.385 0.581618L344.841 0.259521L343.4 7.5556L401.048 88.929L395.15 130.575L399.125 131.589L397.39 132.818C394.102 135.146 389.55 134.368 387.221 131.083L332.696 54.1259Z",
    fill: "#24292E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M406.165 87.8123L400.222 129.778C399.883 132.166 396.801 132.913 395.405 130.945L339.052 51.4011C338.053 49.991 337.63 48.2493 337.874 46.5386L344.299 1.15887C344.471 -0.0460101 346.026 -0.425368 346.73 0.569552L404.929 82.7208C405.977 84.1977 406.418 86.0205 406.165 87.8123Z",
    fill: "#606060"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2539 165.516C72.3568 167.084 70.868 168.26 69.112 168.787L25.419 181.924L25.4047 181.929C24.176 182.327 22.8423 182.22 21.7209 181.628C21.7161 181.626 21.7114 181.623 21.709 181.621L17.3118 179.307L24.3597 177.023L75.7114 87.3113L117.801 73.6735L116.985 69.5889L118.925 70.61C122.599 72.545 123.895 77.0496 121.821 80.6737L73.2539 165.516Z",
    fill: "#24292E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.364 83.1502L114.776 69.4074C117.19 68.6248 119.275 71.0942 118.032 73.2654L67.8355 160.961C66.9456 162.517 65.4854 163.696 63.7556 164.256L17.8939 179.116C16.6747 179.509 15.6226 178.264 16.25 177.169L68.0908 86.6002C69.0237 84.973 70.5507 83.7371 72.364 83.1502Z",
    fill: "#606060"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.78 233.958C123.954 234.111 125.142 233.763 126.216 233.266C128.304 232.302 130.119 230.759 131.408 228.857C134.982 223.582 129.506 220.406 125.362 224.155C123.305 226.016 116.243 233.102 122.78 233.958Z",
    fill: "url(#paint24_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2681 291.422C47.1164 293.589 32.9871 281.397 44.9404 266.819C53.4509 256.395 53.6943 263.553 53.2338 272.137C53.4366 277.513 54.2598 279.755 61.9304 280.853C69.6011 281.95 69.4197 289.256 58.2681 291.422Z",
    fill: "url(#paint25_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.055 157.509C42.7502 158.008 39.9206 156.999 39.2549 154.737C38.551 152.344 40.4526 150.041 42.2062 148.269C44.6995 145.747 47.1952 143.222 49.6884 140.7C50.545 139.834 51.4659 138.613 50.9172 137.527C50.1298 135.969 47.7654 136.909 46.4174 138.016C42.9817 140.836 39.546 143.654 36.1103 146.474L21.9667 171.176L65.7837 157.018L76.2649 138.708C67.2844 142.714 58.8073 147.851 51.108 153.971C49.259 155.438 47.3598 157.01 45.055 157.509Z",
    fill: "url(#paint26_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1024 132.075C75.5134 129.861 76.1027 126.671 77.6321 124.417C79.1638 122.16 81.4519 120.559 83.5062 118.764C85.8825 116.686 88.0346 114.217 89.0868 111.242C90.1413 108.264 89.9314 104.709 87.9606 102.242C87.3737 101.51 86.6126 100.801 86.5506 99.8657C86.4551 98.4532 87.9463 97.5203 89.2299 96.9215C94.2164 94.5881 99.2054 92.2547 104.192 89.9213L112.743 74.9832L68.9259 89.1411L36.1079 146.474C39.5436 143.654 42.9793 140.836 46.415 138.016C47.763 136.909 50.1274 135.971 50.9148 137.527C51.4635 138.613 50.5402 139.837 49.6861 140.7C47.1928 143.222 44.6971 145.746 42.2039 148.268C40.4502 150.041 38.5487 152.346 39.2525 154.737C39.9182 157.001 42.7479 158.008 45.0526 157.509C47.3574 157.01 49.2566 155.438 51.1033 153.971C58.8026 147.851 67.2797 142.714 76.2602 138.708L79.2354 133.509C78.3908 133.268 77.6154 132.786 77.1024 132.075Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2299 96.917C87.9486 97.5158 86.4551 98.4487 86.5505 99.8612C86.6125 100.796 87.376 101.505 87.9606 102.238C89.9313 104.705 90.1413 108.26 89.0867 111.237C88.0321 114.215 85.8824 116.682 83.5061 118.76C81.4542 120.554 79.1638 122.157 77.632 124.412C76.1003 126.669 75.5133 129.857 77.1023 132.071C77.6129 132.784 78.3907 133.264 79.2377 133.505L104.192 89.9167C99.2053 92.2502 94.2164 94.5836 89.2299 96.917Z",
    fill: "url(#paint27_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.858 287.006C109.353 285.632 106.041 287.402 103.741 288.447C103.443 288.583 102.219 289.215 101.787 289.356C100.231 289.864 97.9098 291.103 96.7288 292.558C95.4833 294.894 98.5898 296.841 103.109 296.831C105.852 296.953 108.966 295.913 111.194 294.34C112.461 293.446 113.633 292.212 113.683 290.571C113.726 289.168 113.127 287.703 111.858 287.006Z",
    fill: "url(#paint28_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M349.741 192.637C348.892 191.114 346.229 190.332 342.829 191.055C340.014 191.654 337.42 193.037 335.781 194.502C334.457 195.416 332.78 196.261 331.303 197.084C328.986 198.372 326.627 199.673 324.661 201.116C323.067 202.288 321.886 203.597 322.428 204.762C322.981 205.948 324.973 206.379 327.393 206.165C329.838 205.948 332.374 205.244 334.72 204.495C336.736 203.85 338.723 203.101 340.501 202.214C345.182 199.868 351.366 195.559 349.741 192.637Z",
    fill: "url(#paint29_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M361.571 69.1117C363.534 67.4034 366.822 68.6226 368.253 70.7962C369.687 72.9697 369.852 75.704 370.227 78.2807C370.601 80.8575 371.381 83.6347 373.531 85.1044C376.542 87.1634 381.059 85.4265 382.812 82.227C384.566 79.0275 384.07 75.0049 382.602 71.6646C381.135 68.3244 378.804 65.4518 376.816 62.3907C371.513 54.2237 368.64 44.506 368.599 34.7715L349.605 7.96118L343.433 51.2986L359.881 74.5182C359.893 74.3297 359.908 74.1412 359.92 73.9527C360.039 72.2039 360.249 70.2617 361.571 69.1117Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M401.572 87.6501L402.324 82.3725L392.062 67.8877C392.236 73.788 393.017 79.9222 397.108 84.0116C398.44 85.3453 400.103 86.4404 401.572 87.6501Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M397.109 84.0138C393.014 79.922 392.237 73.7878 392.062 67.8899L368.599 34.7712C368.64 44.5057 371.513 54.2235 376.816 62.3904C378.804 65.4515 381.135 68.3241 382.602 71.6644C384.07 75.0046 384.566 79.0273 382.812 82.2267C381.059 85.4262 376.542 87.1632 373.531 85.1041C371.381 83.6344 370.601 80.8572 370.227 78.2805C369.852 75.7037 369.687 72.9695 368.253 70.7959C366.82 68.6224 363.534 67.4032 361.571 69.1115C360.249 70.2615 360.039 72.2036 359.92 73.9524C359.908 74.1409 359.893 74.3294 359.881 74.5179L388.438 114.83C389.634 111.688 391.561 108.827 394.098 106.62C395.765 105.172 397.655 103.996 399.43 102.681L401.57 87.6499C400.103 86.4402 398.44 85.3451 397.109 84.0138Z",
    fill: "url(#paint30_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M388.438 114.828L396.149 125.712L399.43 102.681C397.657 103.996 395.765 105.17 394.097 106.62C391.561 108.827 389.633 111.688 388.438 114.828Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2828 143.821C47.9729 144.718 46.6177 145.673 45.871 147.073C45.1242 148.474 45.2124 150.456 46.4937 151.392C47.6723 152.251 49.383 151.909 50.5736 151.07C51.7641 150.23 52.5968 148.987 53.5583 147.892C55.6126 145.553 58.2848 143.864 60.8759 142.134C61.8374 141.493 62.8037 140.832 63.5528 139.951C64.302 139.071 64.8174 137.933 64.7124 136.781C64.2925 132.095 60.8401 135.611 59.4372 136.902C56.5311 139.577 52.5467 141.581 49.2828 143.821Z",
    fill: "url(#paint31_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1381 226.827C45.6275 226.827 45.1289 226.624 44.7591 226.249L28.7855 209.963C28.3035 209.472 28.1198 208.763 28.3035 208.1C28.4849 207.436 29.0074 206.921 29.6707 206.744L48.8795 201.667C49.507 201.5 50.1774 201.663 50.6618 202.097C51.1461 202.531 51.3776 203.18 51.2821 203.822L48.0468 225.185C47.9371 225.908 47.4289 226.507 46.7322 226.731C46.5366 226.796 46.3362 226.827 46.1381 226.827ZM33.8651 209.629L44.8092 220.785L47.0257 206.15L33.8651 209.629Z",
    fill: "url(#paint32_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M378.353 185.181C377.954 185.181 377.573 184.978 377.353 184.63C377.074 184.186 377.119 183.613 377.463 183.219L390.559 168.279C390.874 167.919 391.377 167.785 391.831 167.94L409.899 174.105C410.388 174.272 410.713 174.74 410.698 175.258C410.684 175.775 410.336 176.224 409.837 176.365L378.675 185.14C378.568 185.166 378.46 185.181 378.353 185.181ZM391.816 170.431L381.872 181.778L405.538 175.115L391.816 170.431Z",
    fill: "#82FDB8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.013 53.1952C103.163 51.8567 103.562 50.084 104.9 49.2346C110.247 45.8467 114.718 46.6483 118.312 47.2925C121.587 47.8794 124.176 48.3447 127.638 46.1521C131.1 43.9594 131.785 41.4208 132.653 38.207C133.605 34.683 134.789 30.2978 140.138 26.9098C145.485 23.5218 149.956 24.3235 153.549 24.9701C156.825 25.5594 159.413 26.0222 162.873 23.8296C166.333 21.637 167.02 19.0984 167.886 15.8846C168.838 12.3606 170.021 7.97531 175.368 4.58733C180.715 1.19936 185.186 2.00102 188.779 2.6476C192.055 3.23691 194.644 3.69978 198.103 1.50714C199.442 0.657758 201.214 1.0562 202.064 2.39469C202.913 3.73318 202.515 5.5059 201.176 6.35528C195.829 9.74326 191.358 8.94159 187.765 8.29502C184.489 7.7057 181.901 7.24284 178.441 9.43548C174.981 11.6281 174.294 14.1667 173.428 17.3805C172.476 20.9045 171.293 25.2898 165.946 28.6777C160.599 32.0657 156.128 31.2641 152.535 30.6175C149.259 30.0282 146.67 29.5653 143.211 31.7579C139.749 33.9506 139.064 36.4892 138.196 39.703C137.244 43.2269 136.06 47.6122 130.711 51.0002C125.364 54.3882 120.893 53.5865 117.3 52.9423C114.024 52.3554 111.435 51.8901 107.973 54.0828C106.635 54.9298 104.862 54.5337 104.013 53.1952Z",
    fill: "#82FDB8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M214.685 74.3344C218.025 78.1423 220.266 56.6526 211.204 57.0582C202.142 57.4638 191.926 67.7613 201.248 65.7047C209.131 63.9653 209.35 68.2552 214.685 74.3344Z",
    fill: "#86E29B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M252.549 38.2167C250.696 38.2167 248.823 37.7228 247.129 36.6897C242.226 33.6906 240.675 27.263 243.674 22.3576C246.673 17.4546 253.101 15.9038 258.006 18.9028C262.909 21.9019 264.46 28.3295 261.461 33.2349C259.497 36.444 256.064 38.2167 252.549 38.2167ZM252.58 20.2795C250.047 20.2795 247.57 21.5583 246.155 23.8727C243.994 27.4086 245.11 32.0467 248.648 34.2084C252.187 36.37 256.823 35.2534 258.984 31.7151C261.146 28.1792 260.029 23.541 256.491 21.3794C255.267 20.635 253.914 20.2795 252.58 20.2795Z",
    fill: "#FFB0EB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52004 141.953C6.18155 141.953 4.82636 141.597 3.6024 140.848C0.0569536 138.682 -1.06203 134.034 1.10436 130.489C3.27076 126.943 7.91849 125.824 11.4639 127.991C13.1818 129.04 14.3867 130.696 14.8591 132.653C15.3315 134.609 15.0118 136.632 13.962 138.35C12.5424 140.672 10.061 141.953 7.52004 141.953ZM7.54151 128.988C5.71153 128.988 3.92211 129.911 2.89856 131.586C2.14223 132.824 1.91318 134.282 2.25198 135.692C2.59316 137.102 3.46163 138.298 4.69991 139.054C7.25521 140.617 10.605 139.808 12.1678 137.253C12.9241 136.014 13.1531 134.557 12.8143 133.147C12.4732 131.736 11.6047 130.541 10.3664 129.785C9.48364 129.246 8.5078 128.988 7.54151 128.988Z",
    fill: "#FFD23D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M411.336 56.8075C412.946 56.8075 414.251 55.5021 414.251 53.8919C414.251 52.2817 412.946 50.9763 411.336 50.9763C409.725 50.9763 408.42 52.2817 408.42 53.8919C408.42 55.5021 409.725 56.8075 411.336 56.8075Z",
    fill: "url(#paint33_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3711 94.2493C50.9814 94.2493 52.2867 92.944 52.2867 91.3338C52.2867 89.7236 50.9814 88.4182 49.3711 88.4182C47.7609 88.4182 46.4556 89.7236 46.4556 91.3338C46.4556 92.944 47.7609 94.2493 49.3711 94.2493Z",
    fill: "url(#paint34_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2625 243.979C77.8727 243.979 79.1781 242.673 79.1781 241.063C79.1781 239.453 77.8727 238.148 76.2625 238.148C74.6523 238.148 73.3469 239.453 73.3469 241.063C73.3469 242.673 74.6523 243.979 76.2625 243.979Z",
    fill: "url(#paint35_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M190.919 53.8922C192.529 53.8922 193.835 52.5868 193.835 50.9766C193.835 49.3664 192.529 48.061 190.919 48.061C189.309 48.061 188.004 49.3664 188.004 50.9766C188.004 52.5868 189.309 53.8922 190.919 53.8922Z",
    fill: "url(#paint36_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M372.021 177.827C373.631 177.827 374.936 176.522 374.936 174.912C374.936 173.302 373.631 171.996 372.021 171.996C370.411 171.996 369.105 173.302 369.105 174.912C369.105 176.522 370.411 177.827 372.021 177.827Z",
    fill: "url(#paint37_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M329.242 181.015C329.005 181.015 328.772 180.963 328.555 180.858L315.94 174.75C315.363 174.471 315.012 173.869 315.053 173.228C315.093 172.586 315.518 172.035 316.126 171.832L333.498 166.032C334.08 165.838 334.722 165.998 335.144 166.444C335.567 166.891 335.691 167.542 335.462 168.112L330.707 180.02C330.544 180.426 330.22 180.748 329.812 180.905C329.628 180.979 329.435 181.015 329.242 181.015ZM320.803 173.597L328.404 177.279L331.27 170.102L320.803 173.597Z",
    fill: "url(#paint38_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M315.63 54.6341C330.928 52.6872 333.081 59.9642 321.041 71.6909C309.002 83.4176 308.081 74.9811 310.722 67.8615C313.363 60.742 309.42 60.6704 304.023 62.0209C298.621 63.3713 299.54 58.7164 315.63 54.6341Z",
    fill: "#75C4FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 261.041,
    y1: 43.9455,
    x2: 393.346,
    y2: 43.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 265.491,
    y1: 191.15,
    x2: 324.68,
    y2: 191.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 261.039,
    y1: 176.115,
    x2: 287.852,
    y2: 167.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 350.006,
    y1: 120.37,
    x2: 386.482,
    y2: 120.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 34.7299,
    y1: 179.11,
    x2: 61.2988,
    y2: 179.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.04859,
    y1: 193.522,
    x2: 49.0846,
    y2: 193.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 80.2944,
    y1: 88.967,
    x2: 182.46,
    y2: 88.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 389.826,
    y1: 166.038,
    x2: 312.971,
    y2: 166.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 182.049,
    y1: 188.92,
    x2: 102.175,
    y2: 266.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 158.296,
    y1: 271.197,
    x2: 72.7672,
    y2: 271.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 245.978,
    y1: 297.462,
    x2: 245.978,
    y2: 452.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6349,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 230.555,
    y1: 302.943,
    x2: 230.555,
    y2: 427.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 183.671,
    y1: 161.801,
    x2: 183.671,
    y2: 300.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 170.187,
    y1: 176.672,
    x2: 90.3137,
    y2: 254.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 168.465,
    y1: 176.526,
    x2: 267.132,
    y2: 176.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 168.467,
    y1: 305.392,
    x2: 267.131,
    y2: 305.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 270.806,
    y1: 164.449,
    x2: 165.433,
    y2: 164.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 270.807,
    y1: 332.241,
    x2: 165.433,
    y2: 332.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 173.893,
    y1: 234.694,
    x2: 245.892,
    y2: 234.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 196.422,
    y1: 208.496,
    x2: 267.131,
    y2: 208.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 161.756,
    y1: 297.462,
    x2: 161.756,
    y2: 452.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6349,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 161.406,
    y1: 297.462,
    x2: 161.406,
    y2: 452.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6349,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 162.106,
    y1: 297.462,
    x2: 162.106,
    y2: 452.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6349,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 279.732,
    y1: 302.943,
    x2: 279.732,
    y2: 427.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    stopColor: "#CFD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 174.947,
    y1: 181.586,
    x2: 95.073,
    y2: 258.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 96.7434,
    y1: 276.658,
    x2: 60.5164,
    y2: 276.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 21.9668,
    y1: 153.939,
    x2: 76.263,
    y2: 153.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 76.1617,
    y1: 111.713,
    x2: 104.191,
    y2: 111.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 113.686,
    y1: 291.673,
    x2: 96.4528,
    y2: 291.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 350.419,
    y1: 195.211,
    x2: 321.713,
    y2: 201.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 359.881,
    y1: 74.7996,
    x2: 401.572,
    y2: 74.7996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 45.3986,
    y1: 143.156,
    x2: 64.725,
    y2: 143.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 38.3576,
    y1: 202.9,
    x2: 48.8103,
    y2: 225.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 408.421,
    y1: 53.8916,
    x2: 414.251,
    y2: 53.8916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 46.4569,
    y1: 91.3349,
    x2: 52.2876,
    y2: 91.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 73.3476,
    y1: 241.062,
    x2: 79.1783,
    y2: 241.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 188.003,
    y1: 50.9765,
    x2: 193.834,
    y2: 50.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 369.107,
    y1: 174.911,
    x2: 374.937,
    y2: 174.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 315.049,
    y1: 173.484,
    x2: 335.575,
    y2: 173.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIllo);
export default __webpack_public_path__ + "static/media/wallet-illo.d938fa6c5e63ffa64514e73169785863.svg";
export { ForwardRef as ReactComponent };